export const CATEGORY = {
  ALL: '전체',
  COMMUNITY: '커뮤니티',
  EVENT: '이벤트',
  PENALTY: '제재',
  ETC: '기타',
};
